import Http from '../http'

export const index = (page, name) => Http.get(`/colors?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/colors', { data }, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/colors/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/colors/${id}`, { headers: { Authorization: localStorage.token } })
